import { useEffect, useState } from "react";
import { useApi } from "../../api/context";

/** OWN-283: unresolved-error count next to the «الأخطاء» tab; hidden at zero or when unreadable. */
export function FlowErrorsNavBadge({ workspaceId }: { workspaceId: string }) {
  const api = useApi();
  const [count, setCount] = useState(0);
  useEffect(() => {
    let live = true;
    api.listFlowErrors(workspaceId, { status: "unresolved" }).then(
      (r) => live && setCount(r.unresolved),
      () => live && setCount(0),
    );
    return () => {
      live = false;
    };
  }, [api, workspaceId]);
  if (count === 0) return null;
  return (
    <span
      className="rounded-full bg-danger-solid px-1.5 text-xs font-semibold text-on-danger-solid"
      data-testid="flow-errors-nav-badge"
    >
      {count}
    </span>
  );
}
